import { isNull } from "App/utils/helpers";
import { useContext, useState } from "react";
import { useMutation } from "react-query";
import { FormContext } from "../../context/FormContext";
import { getAllJasaByKelas } from "../TabJasa/DaftarJasa/helpers";

const RESET_STATE_FORM_FILTER_JASA = {
  pages: 1,
  limit: 10,
  kelas_id: "",
  asuransi_id: "",
  name: "",
};

const refetchJasaByKelas = async (variables) => {
  if (!isNull(variables.kelas_id) && !isNull(variables.asuransi_id)) {
    const response = await getAllJasaByKelas(
      {
        kelas_id: variables.kelas_id,
        asuransi_id: variables.asuransi_id,
        name: variables.name,
      },
      variables.pages,
      variables.limit
    );
    return {
      data: response.data,
      meta: response.meta,
    };
  } else {
    return {
      data: [],
      meta: {
        count: 0,
        pages: 1,
        limit: 10,
      },
    };
  }
};

export const useDaftarJasaByKelas = () => {
  const { formData } = useContext(FormContext);
  const [formFilterJasaByKelas, setFormFilterJasaByKelas] = useState(
    RESET_STATE_FORM_FILTER_JASA
  );

  const jasas = useMutation({
    mutationFn: (variables) => {
      return refetchJasaByKelas(variables);
    },
  });

  const rowsJasaByKelas = isNull(jasas.data) ? [] : jasas.data.data;
  const totalDataJasaByKelas = isNull(jasas.data) ? 0 : jasas.data.meta.count;
  const loadingJasaByKelas = jasas.isLoading;

  const setNewDataJasaByKelas = (
    pages = formFilterJasaByKelas.pages,
    limit = formFilterJasaByKelas.limit,
    formFilter = formFilterJasaByKelas
  ) => {
    jasas.mutate({
      pages,
      limit,
      kelas_id: formData.kelas_id,
      asuransi_id: formData.asuransi_id,
      name: formFilter.name,
    });
  };

  return {
    loadingJasaByKelas,
    setNewDataJasaByKelas,
    rowsJasaByKelas,
    totalDataJasaByKelas,
    formFilterJasaByKelas,
    setFormFilterJasaByKelas,
  };
};
